class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/tasks`;
    }
    /**
     * Returns the list of tasks of the specified chat.
     * HTTP Method: get
     * Endpoint: /team-messaging/v1/chats/{chatId}/tasks
     * Rate Limit Group: Heavy
     * App Permission: TeamMessaging
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a task in the specified chat.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/chats/{chatId}/tasks
     * Rate Limit Group: Medium
     * App Permission: TeamMessaging
     */
    async post(tMCreateTaskRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), tMCreateTaskRequest, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
